import React from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import SubmitEarlyPayment from './submitEarlyPayment';
import { getUserByPhoneApi } from '../../utils/apisConsts';

const EarlyPayment = () => {
    const componentSteps = [
        {
            title: 'Select User',
            content: <GetInfo apiLink={getUserByPhoneApi} />,
            id: 0,
        },
        {
            title: 'Submit Early Payment',
            content: <SubmitEarlyPayment />,
            id: 1,
        },
    ];

    return (
        <div className='createEarlyPayment'>
            <Stepper componentSteps={componentSteps} />
        </div>
    );
};

export default EarlyPayment;